import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-average-product-onboarding-time',
  templateUrl: './average-product-onboarding-time.component.html',
  styleUrls: ['./average-product-onboarding-time.component.css']
})
export class AverageProductOnboardingTimeComponent implements OnInit {

  @Input() entityDetails: any;
  @Input() widgetData: any;
  @Input() entityId: string;

  constructor() { }

  ngOnInit(): void {
  }

}
